import classNames from 'classnames';
import type { ReactNode } from 'react';
import { useImportManagerState } from '../ImportManagerContext';
import type { TableItem } from '../types';

type ImportTableRowWrapper = {
  item: TableItem;
  children: ReactNode;
};

export const ImportTableRowWrapper = ({
  item,
  children,
}: ImportTableRowWrapper) => {
  const { updateSelectedDemoId } = useImportManagerState();

  return (
    <div
      onClick={() => updateSelectedDemoId(item.id)}
      className={classNames(
        'py-2 px-3 rounded-md mb-1 pointer flex items-center',
        item.selected
          ? 'bg-ds-primary-50'
          : 'hover:bg-ds-natural-50 hover:cursor-pointer'
      )}
    >
      {children}
    </div>
  );
};
